import { cn } from '@/lib/cn';
const PALETTE = ['terre', 'champagne', 'basilic', 'prune', 'velours', 'encre-nuit', 'vieil-or', 'cerise'] as const;
function colorFromName(name: string) {
  let h = 0; for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
function letters(n: string) {
  const w = n.trim().split(/\s+/).filter(w => w.length > 1);
  if (w.length === 0) return n.slice(0, 2).toUpperCase();
  if (w.length === 1) return w[0].slice(0, 2).toUpperCase();
  return (w[0][0] + w[1][0]).toUpperCase();
}
export function Monogram({ name, size = 36, className }: { name: string; size?: number; className?: string }) {
  const c = colorFromName(name);
  // Background is set via inline style (CSS var) because Tailwind's JIT can't
  // detect the dynamic `bg-${c}` class — it was never generated, leaving the
  // monogram invisible (cream text on no background).
  return (
    <span className={cn('inline-flex items-center justify-center rounded-sm font-serif select-none text-paper-elev', className)} style={{ width: size, height: size, fontSize: Math.round(size * 0.5), lineHeight: 1, backgroundColor: `rgb(var(--${c}))` }}>
      {letters(name)}
    </span>
  );
}
